import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({ transform: 'scale3d(.3, .3, .3)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'scale3d(.0, .0, .0)' })),
      ]),
    ]),
  ],
})
export class ModalComponent {
  @Input() closable = true;
  @Input() visible: boolean;
  @Input() isSmall = false;
  @Input() scroll = false;
  @Output() modalClickOutside: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  outsideClicked($event): void {
    if ($event.target.classList.contains('modal-outside-area')) {
      this.modalClickOutside.emit();
    }
  }
}
